import React, { ReactElement } from 'react'
import Template from '../../HelperClass/Template/Row'
import Points from '../../HelperClass/Points'
import { IceHockeyRowProps } from '../../HelperClass/StandingsRowTypes'
import MatchCounter from '../../HelperClass/MatchCounter'
import StatisticsRowItem from '../../HelperClass/RowItem/StatisticsRowItem'
import RowFont from '../../HelperClass/RowFont'

export type Props = IceHockeyRowProps

const IcehockeyRow = ({
    onRowPress,
    rank,
    tendency,
    onMorePress,
    leagueQualifierColor,
    competitorLogoUrl,
    competitorName,
    competitorLogoAlt,
    hasDivider,
    imageType,
    points,
    additionalInfoLabel,
    testID,
    matchCounter,
    win,
    overTimeWin,
    overtimeLoss,
    penaltyShootoutWin,
    penaltyShootoutLose,
    loss,
    pointsPerGame,
    isCompetitorBold,
}: Props): ReactElement => {
    return (
        <Template
            rank={rank}
            testID={testID}
            tendency={tendency}
            onRowPress={onRowPress}
            competitorLogoUrl={competitorLogoUrl}
            leagueQualifierColor={leagueQualifierColor}
            onMorePress={onMorePress}
            competitorName={competitorName}
            additionalInfoLabel={additionalInfoLabel}
            competitorLogoAlt={competitorLogoAlt}
            hasDivider={hasDivider}
            imageType={imageType}
            isCompetitorBold={isCompetitorBold}
        >
            <MatchCounter matchCounter={matchCounter} width={25} />
            <StatisticsRowItem width={18}>
                <RowFont>{win}</RowFont>
            </StatisticsRowItem>
            <StatisticsRowItem display={['flex', 'flex', 'none']} width={25}>
                <RowFont>{overTimeWin + penaltyShootoutWin}</RowFont>
            </StatisticsRowItem>
            <StatisticsRowItem display={['none', 'none', 'flex']} width={25}>
                <RowFont>{overTimeWin}</RowFont>
            </StatisticsRowItem>
            <StatisticsRowItem display={['none', 'none', 'flex']} width={25}>
                <RowFont>{penaltyShootoutWin}</RowFont>
            </StatisticsRowItem>
            <StatisticsRowItem width={18}>
                <RowFont>{loss}</RowFont>
            </StatisticsRowItem>
            <StatisticsRowItem display={['flex', 'flex', 'none']} width={25}>
                <RowFont>{overtimeLoss + penaltyShootoutLose}</RowFont>
            </StatisticsRowItem>
            <StatisticsRowItem display={['none', 'none', 'flex']} width={25}>
                <RowFont>{overtimeLoss}</RowFont>
            </StatisticsRowItem>
            <StatisticsRowItem display={['none', 'none', 'flex']} width={25}>
                <RowFont>{penaltyShootoutLose}</RowFont>
            </StatisticsRowItem>
            <Points bold={!pointsPerGame} points={points} width={30} />
            {pointsPerGame ? <Points points={pointsPerGame} width={30} /> : null}
        </Template>
    )
}

export default IcehockeyRow
